export const getBrowser = () => {
    // FROM https://developer.mozilla.org
    if (window && window.navigator) {
        let sBrowser;
        const sUsrAg = navigator.userAgent;
        // The order matters here, and this may report false positives for unlisted browsers.
        if (sUsrAg.indexOf('Firefox') > -1) {
            sBrowser = 'Mozilla Firefox';
            // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        } else if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
            sBrowser = 'Opera';
            // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
        } else if (sUsrAg.indexOf('Trident') > -1) {
            sBrowser = 'Microsoft Internet Explorer';
            // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
        } else if (sUsrAg.indexOf('Edge') > -1) {
            sBrowser = 'Microsoft Edge';
            // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
        } else if (sUsrAg.indexOf('Chrome') > -1) {
            sBrowser = 'Google Chrome or Chromium';
            // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        } else if (sUsrAg.indexOf('Safari') > -1) {
            sBrowser = 'Apple Safari';
            // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
        } else {
            sBrowser = 'unknown';
        }
        return sBrowser;
    }
    return '';
};

export const isMobileDevice = () => {
    if (window && window.navigator) {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }
    return '';
};

export function getBrowserLanguage() {
    let browserLang;
    const userLang = window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage || window.navigator.systemLanguage;
    if (userLang.toLowerCase() === 'ja' || userLang.toLowerCase() === 'ja-jp') {
        browserLang = '日本語';
    } else if (userLang.toLowerCase() === 'es' || userLang.toLowerCase() === 'es-419' ||
        userLang.toLowerCase() === 'es-ar' || userLang.toLowerCase() === 'es-bo' ||
        userLang.toLowerCase() === 'es-cl' || userLang.toLowerCase() === 'es-co' ||
        userLang.toLowerCase() === 'es-cr' || userLang.toLowerCase() === 'es-do' ||
        userLang.toLowerCase() === 'es-ec' || userLang.toLowerCase() === 'es-es' ||
        userLang.toLowerCase() === 'es-gt' || userLang.toLowerCase() === 'es-hn' ||
        userLang.toLowerCase() === 'es-mx' || userLang.toLowerCase() === 'es-ni' ||
        userLang.toLowerCase() === 'es-pa' || userLang.toLowerCase() === 'es-pe' ||
        userLang.toLowerCase() === 'es-pr' || userLang.toLowerCase() === 'es-py' ||
        userLang.toLowerCase() === 'es-sv' || userLang.toLowerCase() === 'es-uy' ||
        userLang.toLowerCase() === 'es-ve') {
        browserLang = 'Español';
    } else {
        browserLang = 'English';
    }
    return browserLang;
}

export const getPreliminaryQuestionByLanguage = (preliminaryQuestionOption, languageId) => {
    switch (languageId) {
    case 1:
        return preliminaryQuestionOption.description;
    case 2:
        return preliminaryQuestionOption.description_hu;
    case 3:
        return preliminaryQuestionOption.description_jp;
    case 4:
        return preliminaryQuestionOption.description_es;
    default:
        return preliminaryQuestionOption.description;
    }
};
